var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Debug',{attrs:{"label":"Device","data":_vm.deviceInfo,"force-show":true,"expanded":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }